var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowSelectorTool = function SvgArrowSelectorTool(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_selector_tool_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_selector_tool_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.765 20.558q-.479.226-.958.048a1.24 1.24 0 0 1-.705-.658l-2.962-6.364-2.133 2.972q-.385.542-1.014.34-.628-.2-.628-.858V4.608q0-.568.51-.814t.961.106l9.052 7.123q.518.396.3 1.004-.219.607-.867.607h-3.873l2.927 6.26q.227.479.048.958-.18.478-.658.706"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowSelectorTool);
export default ForwardRef;